import {performHttpRequest} from "../http";

export async function getService(id) {
    return performHttpRequest(
        // window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/domain/13/presentation/' + id,
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/bookmarkpresentation/' + id + '/presentation',
        'GET',
    )
}
